export const PHONE_COUNTRY_STORAGE_KEY = 'koin_remit_login_phone_country';

function normalizePhoneCountry(country) {
	const alpha2 = String(country?.alpha2 || '').trim().toUpperCase();
	const callingCode = String(country?.callingCode || '').trim().replace(/^\+/, '');
	if (!/^[A-Z]{2}$/.test(alpha2) || !/^\d{1,4}$/.test(callingCode)) return null;
	return { alpha2, callingCode };
}

export function readPhoneCountry(storage = window.localStorage) {
	try {
		const storedValue = storage.getItem(PHONE_COUNTRY_STORAGE_KEY);
		if (!storedValue) return null;
		return normalizePhoneCountry(JSON.parse(storedValue));
	} catch {
		return null;
	}
}

export function storePhoneCountry(storage = window.localStorage, country) {
	const normalized = normalizePhoneCountry(country);
	if (!normalized) return false;
	try {
		storage.setItem(PHONE_COUNTRY_STORAGE_KEY, JSON.stringify(normalized));
		return true;
	} catch {
		return false;
	}
}
